import { useRef, useEffect } from "react";
import { Typography, Box, Button, Modal, Fade, Backdrop } from "@mui/material";
import { Html5Qrcode } from "html5-qrcode";

const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

interface CodeRedemptionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose: (code: string | null) => void;
}

export const CodeRedemptionModal = ({
  open,
  setOpen,
  onClose,
}: CodeRedemptionModalProps) => {
  const html5QrCodeRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    return () => {
      if (html5QrCodeRef.current) {
        html5QrCodeRef.current
          .stop()
          .catch((error) =>
            console.error("Error stopping QR scanner on unmount:", error),
          );
      }
    };
  }, []);

  useEffect(() => {
    if (!open && html5QrCodeRef.current) {
      html5QrCodeRef.current
        .stop()
        .catch((error) =>
          console.error("Error stopping QR scanner when hidden:", error),
        );
      html5QrCodeRef.current = null;
    }
  }, [open]);

  const startQrScanner = () => {
    // Wait for the DOM to update with the qr-reader element
    setTimeout(() => {
      const html5QrCode = new Html5Qrcode("qr-reader");
      html5QrCodeRef.current = html5QrCode;

      html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
          },
          (decodedText) => {
            const code = decodedText.split("=")[1];
            setOpen(false);
            onClose(code);
          },
          (errorMessage) => {
            console.log(errorMessage);
          },
        )
        .catch((err) => {
          console.error("Error starting QR scanner:", err);
        });
    }, 100);
  };

  useEffect(() => {
    if (open) {
      startQrScanner();
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            Redeem A Code
          </Typography>
          <div style={{ width: "100%", maxWidth: "500px" }}>
            <div id="qr-reader" style={{ width: "100%", height: "100%" }}></div>
          </div>
          <Button onClick={handleClose} style={{ marginTop: 12 }}>
            Close
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default CodeRedemptionModal;
